import { z } from 'zod';
import type { components } from '@/api/generated/schema';

/**
 * Zod schema for `GET /billing/plans` (WEB-611, money HIGH).
 *
 * This is the fix for displayed-price != charged-price: the frontend used
 * to hardcode Pro/Business prices in `constants/billing-display.ts`,
 * independent of the real Stripe Price objects. Now the price is fetched
 * live from this endpoint. A malformed/renamed field here must fail loud
 * (not silently render a blank/zero price) — same reasoning as
 * `billing.schema.ts` (WEB-575 layer 2).
 *
 * `z.ZodType<BillingPlansResponseDto>` pins this schema to the codegen type
 * (layer 1) — a renamed backend field fails this file to compile.
 */
export type BillingPlansResponseDto =
  components['schemas']['BillingPlansResponseDto'];

const planPriceSchema: z.ZodType<
  components['schemas']['PlatformPlanPriceResponseDto']
> = z.object({
  unitAmountCents: z.number(),
  currency: z.string(),
  interval: z.string(),
});

export const billingPlansSchema: z.ZodType<BillingPlansResponseDto> =
  z.object({
    pro: planPriceSchema,
    business: planPriceSchema,
  });
